(function(){
  const els = {
    drawer: document.querySelector('[data-mini-cart]'),
    overlay: document.querySelector('[data-mini-cart-overlay]'),
    items:  document.querySelector('[data-mini-cart-items]'),
    empty:  document.querySelector('[data-mini-cart-empty]'),
    subtotal: document.querySelector('[data-mini-cart-subtotal]')
  };
  let smAutoCloseTimer = null;

  function fmt(n){ try{ return (n/100).toLocaleString(undefined,{style:'currency',currency:Shopify.currency.active}); }catch(e){ return '$'+(n/100).toFixed(2);} }

  function openDrawer(autoClose=false){
    if(!els.drawer||!els.overlay) return;
    if (smAutoCloseTimer){ clearTimeout(smAutoCloseTimer); smAutoCloseTimer=null; }
    els.drawer.hidden=false; els.overlay.hidden=false;
    requestAnimationFrame(()=>{
      els.drawer.classList.add('open');
      els.overlay.classList.add('show');
      els.drawer.setAttribute('aria-hidden','false');
    });
    if (autoClose){
      smAutoCloseTimer = setTimeout(()=>{ closeDrawer(); smAutoCloseTimer=null; }, 8000);
    }
  }

  function closeDrawer(){
    if(!els.drawer||!els.overlay) return;
    if (smAutoCloseTimer){ clearTimeout(smAutoCloseTimer); smAutoCloseTimer=null; }
    els.drawer.classList.remove('open');
    els.overlay.classList.remove('show');
    els.drawer.setAttribute('aria-hidden','true');
    setTimeout(()=>{ els.drawer.hidden=true; els.overlay.hidden=true; }, 200);
  }

  async function getCart(){ const r = await fetch('/cart.js',{credentials:'same-origin'}); return r.json(); }

  async function refreshAndOpen(autoClose=true){
    const cart = await getCart();
    renderCart(cart);
    openDrawer(autoClose);
  }

  function renderCart(cart){
    if(!els.items||!els.empty||!els.subtotal) return;
    els.items.innerHTML = '';
    if(!cart.items.length){
      els.empty.hidden=false; els.subtotal.textContent=fmt(0); return;
    }
    els.empty.hidden=true;
    cart.items.forEach(li=>{
      const wrap = document.createElement('div');
      wrap.className='sm-minicart__item';
      const imgSrc = (li.image||'').replace(/(\.png|\.jpg|\.jpeg|\.webp)(\?.*)?$/,'_120x$1');
      wrap.innerHTML = `
        <a href="${li.url}" aria-label="${li.product_title}">
          <img src="${imgSrc}" alt="">
        </a>
        <div>
          <a class="sm-minicart__title" href="${li.url}">${li.product_title}${li.variant_title && li.variant_title!=='Default Title' ? ' — '+li.variant_title : ''}</a>
          <div class="sm-minicart__price">${fmt(li.final_line_price)}</div>
          <div class="sm-minicart__qty">
            <label style="display:none" for="qty-${li.key}">Qty</label>
            <input id="qty-${li.key}" data-key="${li.key}" type="number" min="0" value="${li.quantity}">
            <button class="sm-minicart__remove" data-remove="${li.key}" type="button">Remove</button>
          </div>
        </div>
        <div></div>
      `;
      els.items.appendChild(wrap);
    });
    els.subtotal.textContent = fmt(cart.items_subtotal_price);

    els.items.querySelectorAll('input[type="number"][data-key]').forEach(inp=>{
      inp.addEventListener('change', async (e)=>{
        const key = e.target.getAttribute('data-key');
        const quantity = Math.max(0, parseInt(e.target.value||0,10));
        await changeLine(key, quantity);
      });
    });
    els.items.querySelectorAll('[data-remove]').forEach(btn=>{
      btn.addEventListener('click', async ()=>{
        const key = btn.getAttribute('data-remove');
        await changeLine(key, 0);
      });
    });
  }

  async function changeLine(key, quantity){
    await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key, quantity})});
    const cart = await getCart(); renderCart(cart);
  }

  function hijackAddToCart(){
    // Capture submit early
    document.addEventListener('submit', async (ev)=>{
      const form = ev.target;
      if(!(form instanceof HTMLFormElement)) return;
      if(!/\/cart\/add/.test(form.action)) return;
      ev.preventDefault();
      ev.stopPropagation();
      const fd = new FormData(form);
      try{
        await fetch('/cart/add.js', {method:'POST', body:fd, headers:{'Accept':'application/json'}});
        await refreshAndOpen(true);
      }catch(e){ console.error(e); window.location.href='/cart'; }
    }, true);

    // Capture add button clicks
    document.addEventListener('click', async (ev)=>{
      const btn = ev.target.closest('button[name="add"], [type="submit"][name="add"]');
      if(!btn) return;
      const form = btn.closest('form');
      if(!form || !/\/cart\/add/.test(form.action)) return;
      btn.removeAttribute('onclick');
      ev.preventDefault();
      ev.stopPropagation();
      const fd = new FormData(form);
      try{
        await fetch('/cart/add.js', {method:'POST', body:fd, headers:{'Accept':'application/json'}});
        await refreshAndOpen(true);
      }catch(e){ console.error(e); window.location.href='/cart'; }
    }, true);
  }

  function bindToggles(){
    document.addEventListener('click', (e)=>{
      const t = e.target.closest('[data-mini-cart-toggle],[data-mini-cart-close],[data-mini-cart-overlay]');
      if(!t) return;
      if(t.hasAttribute('data-mini-cart-toggle')){ e.preventDefault(); refreshAndOpen(false); }
      if(t.hasAttribute('data-mini-cart-close') || t.hasAttribute('data-mini-cart-overlay')){ e.preventDefault(); closeDrawer(); }
    });
    document.addEventListener('keydown', (e)=>{ if(e.key==='Escape') closeDrawer(); });
  }

  // init
  hijackAddToCart();
  bindToggles();
})();
